import * as React from "react";
import { observer } from "mobx-react-lite";
import { Mk8sDraftMobx } from "./../../../../../mst/stores/mk8s.draft";
import { useLocation, useNavigate } from "react-router-dom";

interface Props {
  mk8sDraft: Mk8sDraftMobx;
}
const Mk8sCreateProviderPaperspaceNodePoolAddRaw: React.FC<Props> = ({ mk8sDraft }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [isDone, setIsDone] = React.useState(false);

  React.useEffect(() => {
    if (isDone) {
      navigate(
        `${pathname.replace("-add", "")}${
          mk8sDraft.provider_paperspace.nodePools[mk8sDraft.provider_paperspace.nodePools.length - 1].index
        }`,
      );
      return;
    }

    mk8sDraft.provider_paperspace.addNodePool();
    setIsDone(true);
  }, [isDone]);

  return null;
};

export const Mk8sCreateProviderPaperspaceNodePoolAdd = observer(Mk8sCreateProviderPaperspaceNodePoolAddRaw);
